/**
 * Remove only the final slash run, without regex backtracking over earlier
 * runs. Scan once and slice at most once; unchanged inputs need no slice.
 * @param {string} value
 * @returns {string}
 */
export function trimTrailingSlashes(value) {
  let end = value.length;
  while (end > 0 && value.codePointAt(end - 1) === 47) {
    end -= 1;
  }
  return end === value.length ? value : value.slice(0, end);
}
